import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Stack, Typography, List, ListItemText, Box, TextField, InputAdornment } from "@mui/material";
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import Iconify from "./Iconify";
import MenuPopover from "./MenuPopover";

import Scrollbar from "./Scrollbar";

const resolveLinkPath = (childTo, parentTo) => `${parentTo}/${childTo}`;

const NavItemHeader = (props) => {
    const { item, onOpenSidebar, handleChildItemClick } = props;
    const { MenuName, path, MenuURL, Children, MenuIcon } = item; // <-- Added MenuURL here

    const anchorRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();

    const [open, setOpen] = useState(null);

    const isActiveParent = location.pathname.includes(path);

    const handleClose = () => {
        setOpen(null);
    };

    const navigateMenu = (menuURL, targetPath) => {
        if (menuURL?.includes("|")) {
            handleChildItemClick(menuURL); // special case
        } else {
            navigate(targetPath, { replace: true }); // normal case
        }
    };


    const onExpandChange = (e) => {
        e.preventDefault();
        if (Children.length > 0) {
            setOpen(e.currentTarget);
        } else {
            navigateMenu(MenuURL, path);
        }

    };

    return (
        <>
            {/* ---------- Expanded Sidebar ---------- */}
            {onOpenSidebar === "true" && (
               
                <List
                    onClick={onExpandChange}
                    sx={{
                        borderRadius: "8px",
                        height: 44,
                        my: 0.5,
                        mx: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 1.5,
                        cursor: "pointer",
                        // backgroundColor: isActiveParent ? "#FBE9E7" : "transparent",
                        "&:hover": {
                            backgroundColor: "#FBE9E7",
                            "& .MuiTypography-root": { color: "#E7000B" },
                            "& svg": { color: "#E7000B" },
                        },
                    }}
                >
                    {/* LEFT ICON + TEXT */}
                    <Stack direction="row" alignItems="center" spacing={1}>
                        {MenuIcon && MenuIcon !== "null" && (
                            <Iconify icon={MenuIcon} width={22} height={22} />
                        )}
                        <Typography
                            sx={{
                                fontSize: "14px",
                                fontWeight:  400,
                                wordBreak: "break-word",
                            }}
                        >
                            {MenuName}
                        </Typography>
                    </Stack>

                    {/* RIGHT ARROW */}
                    {Children.length > 0 && (
                        <Icon
                            icon="ic:baseline-chevron-right"
                            width="17"
                            height="17"
                            style={{ color: "#000" }}
                        />
                    )}
                    </List>
              
            )}

            {/* ---------- Popover ---------- */}
            <MenuPopover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                PaperProps={{
                    sx: {
                        ml: 1,
                        width: 250,
                        border: "1px solid #E5E7EB",
                        borderRadius: 0,
                        boxShadow: "none",
                         py: 1,
                    },
                }}
            >
                <Scrollbar
                    sx={{
                        "& .simplebar-content": {
                            display: "flex",
                            flexDirection: "column",
                        },
                    }}
                >
                    {Children.map((item, index) => {
                        const childPath = resolveLinkPath(
                            (item.MenuAlias || "").trim().toLowerCase().replace(/\s+/g, ""),
                            props.item.path
                        );

                        const isActiveChild = location.pathname === childPath;

                        return (
                            <Box
                                key={`${item.MenuName}-${index}`}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    px: 1.5,
                                    py: 1,
                                    // backgroundColor: isActiveChild ? "#FBE9E7" : "transparent",
                                    "&:hover": {
                                        backgroundColor: "#FBE9E7",
                                        "& .MuiTypography-root": { color: "#E7000B" },
                                        "& svg": { color: "#E7000B" },
                                        borderLeft: "3px solid #E7000B" 

                                    },
                                }}
                                onClick={() => {
                                    navigateMenu(item.MenuURL, childPath);
                                    handleClose();
                                }}
                            >
                                <Box style={{ marginRight: 12, display: "flex", alignItems: "center" }}>
                                    <Icon icon="ic:baseline-chevron-right" width={18} height={18} />
                                </Box>
                                <Typography
                                    sx={{
                                        fontSize: "12px",
                                        fontWeight:  400,
                                    }}
                                >
                                    {item.MenuName}
                                </Typography>
                            </Box>
                        );
                    })}

                </Scrollbar>
            </MenuPopover>
        </>
    );
};

export default NavItemHeader;
